export default function (userInputs, labels, store) {
    const basket = []
    const donationAmount = userInputs.find(
        (item) => item.name === 'donationAmount'
    )
    const amount = userInputs.find((item) => item.name === 'amount')

    if (donationAmount && donationAmount.value && amount && amount.value) {
        basket.push({
            label: labels.yourInformationTotalTaendteLysLabel,
            amount: `${donationAmount.value} ${labels.taendEtLysUnitLabel} (á ${amount.value} kr.)`,
            price: `${donationAmount.value * amount.value} kr.`,
            intPrice: donationAmount.value * amount.value
        })
    }

    store.dispatch('donation/basket', { basket: basket })
}
